const KEYS = {
  locale: 'locale',
  orderHistory: {
    all: 'orderHistory.all',
    discountApplied: 'orderHistory.discountApplied',
    f1Address: 'orderHistory.f1Address',
    f1DigitalManagement: 'orderHistory.f1DigitalManagement',
    last30Days: 'orderHistory.last30Days',
    noOrders: 'orderHistory.noOrders',
    orderDate: 'orderHistory.orderDate',
    orderHistoryHeader: 'orderHistory.orderHistoryHeader',
    orderNumber: 'orderHistory.orderNumber',
    orderType: 'orderHistory.orderType',
    orderTotal: 'orderHistory.orderTotal',
    originalAmount: 'orderHistory.originalAmount',
    past6Months: 'orderHistory.past6Months',
    past12Months: 'orderHistory.past12Months',
    refundAmount: 'orderHistory.refundAmount',
    status: 'orderHistory.status',
    subTotal: 'orderHistory.subTotal',
    subTotalAmount: 'orderHistory.subTotalAmount',
    tax: 'orderHistory.tax',
    taxInvoice: 'orderHistory.taxInvoice',
    taxRefund: 'orderHistory.taxRefund',
    totalAmount: 'orderHistory.totalAmount',
    type: 'orderHistory.type',
  },
  registration: {
    title: 'registration.title',
    firstName: 'registration.firstName',
    lastName: 'registration.lastName',
    dateOfBirth: 'registration.dateOfBirth',
    countryOfResidence: 'registration.countryOfResidence',
    emailAddress: 'registration.emailAddress',
    password: 'registration.password',
    recieveLatestNews: 'registration.recieveLatestNews',
    confirmationTCPrelude: 'registration.confirmationTCPrelude',
    termsAndConditionsLink: 'registration.termsAndConditionsLink',
    confirmationTCInterlude: 'registration.confirmationTCInterlude',
    privacyPolicyLink: 'registration.privacyPolicyLink',
    confirmationTCPostlude: 'registration.confirmationTCPostlude',
    selectTitle: 'registration.selectTitle',
    select: 'registration.select',
    createAccount: 'registration.createAccount',
    signUpf1: 'registration.signUpf1',
    register: 'registration.register',
    back: 'registration.back',
    serviceError: 'registration.serviceError',
    alreadyHaveAccount: 'registration.alreadyHaveAccount',
    passwordRequirement: 'registration.passwordRequirement',
    showPassword: 'registration.showPassword',
    hidePassword: 'registration.hidePassword',
    loginAlreadyExists: 'registration.loginAlreadyExists',
  },
  signIn: {
    emailAlreadyRegistered: 'signIn.emailAlreadyRegistered',
    signInAccount: 'signIn.signInAccount',
    signIn: 'signIn.signIn',
    forgotPassword: 'signIn.forgotPassword',
    doNotHaveAnAccountYet: 'signIn.doNotHaveAnAccountYet',
    registerWithF1: 'signIn.registerWithF1',
    EnterYourUsername: 'signIn.EnterYourUsername',
    EnterYourPassword: 'signIn.EnterYourPassword',
  },
  accountInfo: {
    personalInformationTitle: 'accountInfo.personalInformationTitle',
    cancel: 'accountInfo.cancel',
    save: 'accountInfo.save',
    edit: 'accountInfo.edit',
    name: 'accountInfo.name',
    dateOfBirth: 'accountInfo.birthday',
    countryOfResidence: 'accountInfo.countryOfResidence',
    emailAddress: 'accountInfo.emailAddress',
    password: 'accountInfo.password',
    currentPassword: 'accountInfo.currentPassword',
    newPassword: 'accountInfo.newPassword',
    newEmailAddress: 'accountInfo.newEmailAddress',
    confirmNewEmailAddress: 'accountInfo.confirmNewEmailAddress',
    emailAddressError: 'accountInfo.emailAddressError',
    requiredPassword: 'accountInfo.requiredPassword',
    passwordsMustBeDifferentError: 'accountInfo.passwordsMustBeDifferentError',
    receiveLatestNews: 'accountInfo.receiveLatestNews',
  },
  subscriptionInfo: {
    subscriptions: {
      subscriptionsHeader: 'subscriptionInfo.subscriptions.subscriptionsHeader',
      paymentHeader: 'subscriptionInfo.subscriptions.paymentHeader',
      change: 'subscriptionInfo.subscriptions.change',
      paymentListDefault: 'subscriptionInfo.subscriptions.paymentListDefault',
      paymentListEdit: 'subscriptionInfo.subscriptions.paymentListEdit',
      changeCardPayment: 'subscriptionInfo.subscriptions.changeCardPayment',
      preferredPaymentMethod:
        'subscriptionInfo.subscriptions.preferredPaymentMethod',
      selected: 'subscriptionInfo.subscriptions.selected',
      select: 'subscriptionInfo.subscriptions.select',
      selectPlaceholder: 'subscriptionInfo.subscriptions.selectPlaceholder',
      noSubscriptions: 'subscriptionInfo.subscriptions.noSubscriptions',
      subscriptionAmountLabel:
        'subscriptionInfo.subscriptions.subscriptionAmountLabel',
      subscriptionItemNextPaymentDateLabel:
        'subscriptionInfo.subscriptions.subscriptionItemNextPaymentDateLabel',
      subscriptionItemRenewalDate:
        'subscriptionInfo.subscriptions.subscriptionItemRenewalDate',
      subscriptionItemRenewalAmount:
        'subscriptionInfo.subscriptions.subscriptionItemRenewalAmount',
      upgradeOrderHelperText:
        'subscriptionInfo.subscriptions.upgradeOrderHelperText',
      subscriptionPlatformLabel:
        'subscriptionInfo.subscriptions.subscriptionPlatformLabel',

      current: 'subscriptionInfo.subscriptions.current',
      backToMySubscription:
        'subscriptionInfo.subscriptions.backToMySubscription',
      reviewYourUpgradeOrder:
        'subscriptionInfo.subscriptions.reviewYourUpgradeOrder',
      upgradeNow: 'subscriptionInfo.subscriptions.upgradeNow',
      monthly: 'subscriptionInfo.subscriptions.monthly',
      yearly: 'subscriptionInfo.subscriptions.yearly',
      year: 'subscriptionInfo.subscriptions.year',
      month: 'subscriptionInfo.subscriptions.month',
      getPremium: 'subscriptionInfo.subscriptions.getPremium',
      manageSubscription: 'subscriptionInfo.subscriptions.manageSubscription',
      upgradeSubscription: 'subscriptionInfo.subscriptions.upgradeSubscription',
      upgrade: 'subscriptionInfo.subscriptions.upgrade',
      purchase: 'subscriptionInfo.subscriptions.purchase',
      subscriptionUpgradeDescription:
        'subscriptionInfo.subscriptions.subscriptionUpgradeDescription',
      appBasedSubscriptionDescription:
        'subscriptionInfo.subscriptions.appBasedSubscriptionDescription',
      f1apponapple: 'subscriptionInfo.subscriptions.ioscore',
      f1tvapponapple: 'subscriptionInfo.subscriptions.iostv',
      f1apponandroid: 'subscriptionInfo.subscriptions.androidcore',
      f1tvapponandroid: 'subscriptionInfo.subscriptions.android',
      roku: 'subscriptionInfo.subscriptions.roku',
      amazonfire: 'subscriptionInfo.subscriptions.amazon',
      subscriptionStartDate:
        'subscriptionInfo.subscriptions.subscriptionStartDate',
      newSubscriptionAmount:
        'subscriptionInfo.subscriptions.newSubscriptionAmount',
      removePayment: 'subscriptionInfo.subscriptions.removePayment',
      subscriptionItemCancelSubscriptionButtonLabel:
        'subscriptionInfo.subscriptions.subscriptionItemCancelSubscriptionButtonLabel',
      subscriptionItemRenewSubscriptionButtonLabel:
        'subscriptionInfo.subscriptions.subscriptionItemRenewSubscriptionButtonLabel',

      statusName: 'subscriptionInfo.subscriptions.statusName',
      close: 'subscriptionInfo.subscriptions.close',
      paymentFormNameField:
        'subscriptionInfo.subscriptions.paymentFormNameField',
      paymentFormBillingAddress:
        'subscriptionInfo.subscriptions.paymentFormBillingAddress',
      paymentFormCardNumberField:
        'subscriptionInfo.subscriptions.paymentFormCardNumberField',
      paymentFormSecurityCodeField:
        'subscriptionInfo.subscriptions.paymentFormSecurityCodeField',
      paymentFormExpirationDateField:
        'subscriptionInfo.subscriptions.paymentFormExpirationDateField',
      threeOnBack: 'subscriptionInfo.subscriptions.threeOnBack',
      paymentFormDelete: 'subscriptionInfo.subscriptions.paymentFormDelete',
      paymentFormSave: 'subscriptionInfo.subscriptions.paymentFormSave',
      paymentFormCancel: 'subscriptionInfo.subscriptions.paymentFormCancel',
      paymentFormAddNewAddress:
        'subscriptionInfo.subscriptions.paymentFormAddNewAddress',
      paymentInstrumentIconTypeCard:
        'subscriptionInfo.subscriptions.paymentInstrumentIconTypeCard',
      paymentInstrumentIconTypePaypal:
        'subscriptionInfo.subscriptions.paymentInstrumentIconTypePaypal',
      paymentInstrumentIconTypeLink:
        'subscriptionInfo.subscriptions.paymentInstrumentIconTypeLink',
      paymentInstrumentIconTypeApple:
        'subscriptionInfo.subscriptions.paymentInstrumentIconTypeApple',
      removePaymentCancel: 'subscriptionInfo.subscriptions.removePaymentCancel',
      removePaymentRemove: 'subscriptionInfo.subscriptions.removePaymentRemove',
      removePaymentConfirmationText:
        'subscriptionInfo.subscriptions.removePaymentConfirmationText',
      addressFormLineOne: 'subscriptionInfo.subscriptions.addressFormLineOne',
      addressFormLineTwo: 'subscriptionInfo.subscriptions.addressFormLineTwo',
      optional: 'subscriptionInfo.subscriptions.optional',
      addressFormCity: 'subscriptionInfo.subscriptions.addressFormCity',
      addressFormRegion: 'subscriptionInfo.subscriptions.addressFormRegion',
      addressFormState: 'subscriptionInfo.subscriptions.addressFormState',
      addressFormProvince: 'subscriptionInfo.subscriptions.addressFormProvince',
      addressFormPostalCode:
        'subscriptionInfo.subscriptions.addressFormPostalCode',
      addressFormZipCode: 'subscriptionInfo.subscriptions.addressFormZipCode',
      addressFormZipPlaceholder:
        'subscriptionInfo.subscriptions.addressFormZipPlaceholder',
      addressFormCountry: 'subscriptionInfo.subscriptions.addressFormCountry',
      subscriptionItemCycleEndDateLabel:
        'subscriptionInfo.subscriptions.subscriptionItemCycleEndDateLabel',
      subscriptionItemUpgradeLink:
        'subscriptionInfo.subscriptions.subscriptionItemUpgradeLink',
      subscriptionTrialItemNextPaymentDateLabel:
        'subscriptionInfo.subscriptions.subscriptionTrialItemNextPaymentDateLabel',
      subscriptionAmountNote:
        'subscriptionInfo.subscriptions.subscriptionAmountNote',
      subscriptionTrialNote:
        'subscriptionInfo.subscriptions.subscriptionTrialNote',
      subscriptionAmountNoteLabel:
        'subscriptionInfo.subscriptions.subscriptionAmountNoteLabel',
      appStoreText: 'subscriptionInfo.subscriptions.appStoreText',
      appStoreHeader: 'subscriptionInfo.subscriptions.appStoreHeader',
      noPaymentDetails: 'subscriptionInfo.subscriptions.noPaymentDetails',
      paymentFormCoreInvalidPaymentInstrumentFault:
        'subscriptionInfo.subscriptions.paymentFormCoreInvalidPaymentInstrumentFault',
      subscribeButtonText: 'subscriptionInfo.subscriptions.subscribeButtonText',
      paymentFormCvvField: 'subscriptionInfo.subscriptions.paymentFormCvvField',
    },
    devices: {
      added: 'subscriptionInfo.devices.added',
      cancel: 'subscriptionInfo.devices.cancel',
      devicesHeader: 'subscriptionInfo.devices.devicesHeader',
      deviceListDeleteConfirmation:
        'subscriptionInfo.devices.deviceListDeleteConfirmation',
      deviceRemove: 'subscriptionInfo.devices.deviceRemove',
      deviceSubHeaderPrefix: 'subscriptionInfo.devices.deviceSubHeaderPrefix',
      deviceSubHeader: 'subscriptionInfo.devices.deviceSubHeader',
      deviceSubHeaderSuffix: 'subscriptionInfo.devices.deviceSubHeaderSuffix',
      deviceType: 'subscriptionInfo.devices.deviceType',
      edit: 'subscriptionInfo.devices.edit',
      nickName: 'subscriptionInfo.devices.nickName',
      noDevices: 'subscriptionInfo.devices.noDevices',
      remove: 'subscriptionInfo.devices.remove',
      save: 'subscriptionInfo.devices.save',
    },
  },
  payment: {
    orders: {
      orderTitle: 'payment.orders.orderTitle',
      modifyOrder: 'payment.orders.modifyOrder',
      billed: 'payment.orders.billed',
      subscriptionCycleType0: 'payment.orders.subscriptionCycleType0',
      subscriptionCycleType1: 'payment.orders.subscriptionCycleType1',
      subscriptionCycleType2: 'payment.orders.subscriptionCycleType2',
      subscriptionCycleType3: 'payment.orders.subscriptionCycleType3',
      subscriptionCycleType4: 'payment.orders.subscriptionCycleType4',
      subscriptionCycleType5: 'payment.orders.subscriptionCycleType5',
      subscriptionCycleType6: 'payment.orders.subscriptionCycleType6',
      subscriptionCycleType7: 'payment.orders.subscriptionCycleType7',
      subscriptionQuoteRenewalCycle:
        'payment.orders.subscriptionQuoteRenewalCycle',
      total: 'payment.orders.total',
      subscriptionItemApplyCouponHeaderLabel:
        'payment.orders.subscriptionItemApplyCouponHeaderLabel',
      subscriptionItemApplyCouponIsRequired:
        'payment.orders.subscriptionItemApplyCouponIsRequired',
      subscriptionItemApplyCouponButtonLabel:
        'payment.orders.subscriptionItemApplyCouponButtonLabel',
      paymentFormCancel: 'payment.orders.paymentFormCancel',
      removeFromOrder: 'payment.orders.removeFromOrder',
      stripePaymentCard: 'payment.orders.stripePaymentCard',
      orderPrivacyPolicy: 'payment.orders.orderPrivacyPolicy',
      subscriptionDisclaimText: 'payment.orders.subscriptionDisclaimText',
      completeOrder: 'payment.orders.completeOrder',
      acceptTermsAndConditions: 'payment.orders.acceptTermsAndConditions',
      payments: 'payment.orders.payments',
      noOrderablePricingPlanMessage:
        'payment.orders.noOrderablePricingPlanMessage',
      subscriptionDislaimerTextPrefix:
        'payment.orders.subscriptionDislaimerTextPrefix',
      subscriptionDislaimerTCLink: 'payment.orders.subscriptionDislaimerTCLink',
      subscriptionDislaimerTextSuffix:
        'payment.orders.subscriptionDislaimerTextSuffix',
      termsTextPrefix: 'payment.orders.termsTextPrefix',
      termsTextTCLink: 'payment.orders.termsTextTCLink',
      termsTextInter1: 'payment.orders.termsTextInter1',
      termsTextPPLink: 'payment.orders.termsTextPPLink',
      termsTextInter2: 'payment.orders.termsTextInter2',
      termsTextSTLink: 'payment.orders.termsTextSTLink',
      termsTextSuffix: 'payment.orders.termsTextSuffix',
    },
  },
  retention: {
    retentionMessageLine1: 'retention.retentionMessageLine1',
    retentionMessageLine2Prefix: 'retention.retentionMessageLine2Prefix',
    retentionMessageLine2Amount: 'retention.retentionMessageLine2Amount',
    retentionMessageLine2SuffixSingular:
      'retention.retentionMessageLine2SuffixSingular',
    retentionMessageLine2SuffixPlural:
      'retention.retentionMessageLine2SuffixPlural',
    retentionMessageLine3Singular: 'retention.retentionMessageLine3Singular',
    retentionMessageLine3Plural: 'retention.retentionMessageLine3Plural',

    retentionRedeemOffer: 'retention.retentionRedeemOffer',
    retentionKeepMySubscription: 'retention.retentionKeepMySubscription',

    termsAndConditionsLine1: 'retention.termsAndConditionsLine1',
    termsAndConditionsLine2: 'retention.termsAndConditionsLine2',
    termsAndConditionsLine3: 'retention.termsAndConditionsLine3',

    retentionTermsAndConditionsLine1:
      'retention.retentionTermsAndConditionsLine1',
    retentionTermsAndConditionsLine2:
      'retention.retentionTermsAndConditionsLine2',
    retentionTermsAndConditionsLine3:
      'retention.retentionTermsAndConditionsLine3',
    retentionTermsAndConditionsLine4:
      'retention.retentionTermsAndConditionsLine4',
    retentionTermsAndConditionsLine5:
      'retention.retentionTermsAndConditionsLine5',
    retentionTermsAndConditionsLine6:
      'retention.retentionTermsAndConditionsLine6',

    singleMonth: 'retention.singleMonth',
    pluralMonth: 'retention.pluralMonth',

    notForYouTitle: 'retention.notForYouTitle',
    sorryToSeeYouGo: 'retention.sorryToSeeYouGo',
    reasonForCancellation: 'retention.reasonForCancellation',
    continueCancellation: 'retention.continueCancellation',

    terminationReason: 'retention.terminationReason',
    postCancellationTitle: 'retention.postCancellationTitle',
    postCancellationMessage1: 'retention.postCancellationMessage1',
    postCancellationMessage2: 'retention.postCancellationMessage2',
    postCancellationBack: 'retention.postCancellationBack',
    appliedOfferTitle: 'retention.appliedOfferTitle',
    appliedOfferMessage1: 'retention.appliedOfferMessage1',
    appliedOfferMessage2: 'retention.appliedOfferMessage2',
    appliedOfferMessage3: 'retention.appliedOfferMessage3',

    retentionOfferTitle: 'retention.retentionOfferTitle',
    retentionOfferContinueCancellation:
      'retention.retentionOfferContinueCancellation',
    retentionOfferRedeemMyOffer: 'retention.retentionOfferRedeemMyOffer',
    retentionOfferBack: 'retention.retentionOfferBack',
    appliedOfferHeading: 'retention.appliedOfferHeading',

    appliedOfferDescription: 'retention.appliedOfferDescription',

    appliedOfferDetail: 'retention.appliedOfferDetail',
    appliedOfferCancelSubscription: 'retention.appliedOfferCancelSubscription',
    appliedOfferBackToSubscriptions:
      'retention.appliedOfferBackToSubscriptions',
    benefitsViewTitle: 'retention.benefitsViewTitle',
    benefitsViewSubheading: 'retention.benefitsViewSubheading',
    benefitsViewLeftBehind: 'retention.benefitsViewLeftBehind',
    benefitsViewGetAHeadStart: 'retention.benefitsViewGetAHeadStart',
    benefitsViewDismiss: 'retention.benefitsViewDismiss',
    benefitsViewContinue: 'retention.benefitsViewContinue',
    retentionOfferDetailsDescription:
      'retention.retentionOfferDetailsDescription',
    retentionOfferTermsAndConditionsTitle:
      'retention.retentionOfferTermsAndConditionsTitle',
    retentionOfferTermsAndConditions1:
      'retention.retentionOfferTermsAndConditions1',
    retentionOfferTermsAndConditions2:
      'retention.retentionOfferTermsAndConditions2',
    retentionOfferTermsAndConditions3:
      'retention.retentionOfferTermsAndConditions3',
    retentionOfferTermsAndConditions4:
      'retention.retentionOfferTermsAndConditions4',
    retentionOfferTermsAndConditions5:
      'retention.retentionOfferTermsAndConditions5',
    retentionOfferTermsAndConditions6:
      'retention.retentionOfferTermsAndConditions6',
    retentionOfferTermsAndConditions7:
      'retention.retentionOfferTermsAndConditions7',

    errorDialogTitle: 'retention.errorDialogTitle',
    errorDialogDetail: 'retention.errorDialogDetail',
    errorDialogClose: 'retention.errorDialogClose',
    updateTerminationReasonTitle: 'retention.updateTerminationReasonTitle',
    updateTerminationReasonValidUntil:
      'retention.updateTerminationReasonValidUntil',
    updateTerminationReasonBack: 'retention.updateTerminationReasonBack',
    subscriptionItemOfferTitle: 'retention.subscriptionItemOfferTitle',
    subscriptionItemOfferIcon: 'retention.subscriptionItemOfferIcon',
    subscriptionItemOfferText: 'retention.subscriptionItemOfferText',
    subscriptionItemOfferCTA: 'retention.subscriptionItemOfferCTA',
    cancellationReasonTitle: 'retention.cancellationReasonTitle',
    cancellationReasonSubtitle: 'retention.cancellationReasonSubtitle',
    cancellationFormSelectDefaultValue:
      'retention.cancellationFormSelectDefaultValue',
    subscriptionItemCancelSubscriptionMessageFormat:
      'retention.subscriptionItemCancelSubscriptionMessageFormat',
    cancellationFormSave: 'retention.cancellationFormSave',
    cancellationFormCancel: 'retention.cancellationFormCancel',
    renewSubscriptionTitle: 'retention.renewSubscriptionTitle',
    renewSubscriptionContent: 'retention.renewSubscriptionContent',
    renewSubscriptionFormRenewButton:
      'retention.renewSubscriptionFormRenewButton',
    renewSubscriptionFormCancelButton:
      'retention.renewSubscriptionFormCancelButton',
    cancellationConfirmationHeader: 'retention.cancellationConfirmationHeader',
    cancellationConfirmationContent:
      'retention.cancellationConfirmationContent',
    cancellationConfirmationClose: 'retention.cancellationConfirmationClose',
  },
  freeTrial: {
    image: 'freeTrial.image',
    altText: 'freeTrial.altText',
    information: 'freeTrial.information',
  },
  errors: {
    general: 'errors.general',
    isRequired: 'errors.isRequired',
  },
  fields: {
    title: 'fields.title',
    firstName: 'fields.firstName',
    lastName: 'fields.lastName',
    dateOfBirth: 'fields.dateOfBirth',
    countryOfResidence: 'fields.countryOfResidence',
    emailAddress: 'fields.emailAddress',
    password: 'fields.password',
    recieveLatestNews: 'fields.recieveLatestNews',
    confirmationTC: 'fields.confirmationTC',
  },
  fault_prefix: 'fault.',
  common: {
    creditCardDescriptor: 'common.creditCardDescriptor',
    introPricing: {
      introPricingLogo: 'common.introPricing.introPricingLogo',
      discountPriceLineCurrencySymbol:
        'common.introPricing.discountPriceLineCurrencySymbol',
      discountPriceText: 'common.introPricing.discountPriceText',
      discountPricePeriod: 'common.introPricing.discountPricePeriod',
      afterDiscountPrefix: 'common.introPricing.afterDiscountPrefix',
      afterDiscountPrice: 'common.introPricing.afterDiscountPrice',
      afterDiscountSuffix: 'common.introPricing.afterDiscountSuffix',
      introPriceDiscountPeriodSingularMonth:
        'common.introPricing.introPriceDiscountPeriodSingularMonth',
      introPriceDiscountPeriodPluralMonths:
        'common.introPricing.introPriceDiscountPeriodPluralMonths',
      introPriceDiscountPeriodSingularYear:
        'common.introPricing.introPriceDiscountPeriodSingularYear',
      introPriceDiscountPeriodPluralYears:
        'common.introPricing.introPriceDiscountPeriodPluralYears',
      singularPerMonth: 'common.introPricing.singularPerMonth',
      singularPerYear: 'common.introPricing.singularPerYear',
    },
  },
  titles: {
    Mr: 'titles.Mr',
    Mrs: 'titles.Mrs',
    Miss: 'titles.Miss',
    Ms: 'titles.Ms',
  },
};

export default KEYS;
